const closingGetters = {
    campaigns: {
        getId: (params) => params.data.campaign.id,
        getName: (params) => params.data.campaign.name,
        getMultiMonth: (params) => params.data.campaign.is_campaign_longer_than_one_month ? "Si" : "No",
        getFromDate: (params) => params.data.campaign.start_date,
        getToDate: (params) => params.data.campaign.end_date,
        getBusinessModel: (params) => params.data.campaign.external_dsp.id ? 'DSP externo' : 'DSP propio',
        getExternalDsp: (params) => params.data.campaign.external_dsp.id ? `${params.data.campaign.external_dsp.name} (${params.data.campaign.external_dsp.exchange})` : 'LatinAd',
        getCampaignType: (params) => params.data.campaign.is_programmatic ? 'Programática' : 'Tradicional',
        getComment: (params) => params.data.campaign.comments
    },
    operation: {
        getGuaranteed: (params) => params.data.operation.is_guaranteed ? 'Si' : 'No', // Aún no está implementado
        getCurrencyToPay: (params) => params.data.operation.currency_to_pay,
        getAmountConsumed: (params) => params.data.operation.amount_consumed,
        getAmountBudgeted: (params) => params.data.operation.amount_budgeted,
        getAmountFinal: (params) => { // PROBAR
            //Si es garantizado, toma 'estimado', si no es garantizado toma 'consumido'
            const value = params.data.operation.guarantee ? params.data.operation.amount_budgeted : params.data.operation.amount_consumed
        
            return value
        },
        getTax: (params) => (params.data.operation.tax ? `${parseFloat(params.data.operation.tax)}%` : '-'),
        getFinalWithTax: (params) => {
            const value = params.data.operation.guarantee ? params.data.operation.amount_budgeted : params.data.operation.amount_consumed
            const tax = params.data.operation.tax ? parseFloat(params.data.operation.tax) : 0

            const finalWithTax = parseFloat(value) + (parseFloat(value) * (tax/100))
            if (!finalWithTax) return 0

            return finalWithTax
        },
        getRateFrom: (params) => params.data.operation.rate,
        getExternalAmountConsumed: (params) => params.data.operation.external_amount_consumed ? params.data.operation.external_amount_consumed : '-',
        getMatchData: (params) => {
            const finalWithTax = Math.floor(closingGetters.operation.getFinalWithTax(params))
            const totalAmountOC = Math.floor(closingGetters.other.getTotalAmountOC(params))

            if (!finalWithTax || !totalAmountOC) return '-'

            return finalWithTax === totalAmountOC ? 1 : 0
        }
    }, 
    company: {
        getId: (params) => params.data.company.id,
        getName: (params) => params.data.company.name,
        getHolding: (params) => (params.data.company.holding ? `${params.data.company.holding.name} (${params.data.company.holding.id})` : '-'),
        getCountry: (params) => params.data.company.country
    },
    other: {
        getPurchaseOrderData: (params) => {
            const { campaign, company, operation } = params.data
            return {
                campaignId: campaign.id,
                companyId: company.id,
                isProgrammatic: campaign.is_programmatic,
                totalIncome: operation.amount_consumed
            }
        },
        getPoIsClosed: (params) => {
            let isClosed = false
            if (params.data.purchase_order_monthly) {
                isClosed = Boolean(params.data.purchase_order_monthly.is_closed)
            }
            return {
                label: isClosed ? 'Cerrada' : 'Por cerrar',
                completed: isClosed,
                transparent: true
            }
        },
        getPoIsSent: (params) => {
            let isSent = false
            if (params.data.purchase_order_monthly) {
                isSent = Boolean(params.data.purchase_order_monthly.email_send_at)
            }
            return {
                label: isSent ? 'Enviada' : 'No enviada',
                completed: isSent,
                transparent: true
            }
        },
        getTotalAmountOC: (params) => {
            const { purchase_order_monthly } = params.data
            if (!purchase_order_monthly) return 0

            return purchase_order_monthly.total_amount
        }
    }
}

export default closingGetters